import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import Close from 'react-icons/lib/io/close';
import DialogWrapper from '../../../components/dialog/Dialog';
import Logo from '../../../assets/images/logo-main-white.svg';
import {isGuest, setUserProperties} from '../../../utils/userUtility';
import {DialogTypes} from '../../../constants/enums';

@inject('dialogStore')
@observer
class StudioAbilities extends Component {
    handleClose = () => {
        if (!isGuest()) {
            setUserProperties({studioAbilities: true});
        }
        this.props.dialogStore.closeDialog(DialogTypes.StudioAbilities);
    };

    render() {
        return (
            <DialogWrapper
                BackdropProps={{classes: {root: 'overlay'}}}
                classes={{root: 'm-abilities-root', paper: 'paper'}}
                open={this.props.dialogStore.getDialogState(DialogTypes.StudioAbilities)}
                onBackdropClick={this.handleClose}>
                <div className="m-studio-abilities">
                    <button className="abilities-close" onClick={this.handleClose}>
                        <Close />
                    </button>
                    <div className="abilities-icon">
                        <img src={Logo} alt=""/>
                    </div>
                    <div className="abilities-title">
                        <FormattedMessage id="studio.abilities.title"/>
                    </div>
                    <div className="abilities-description">
                        <FormattedMessage id={`studio.abilities.${isGuest() ? 'guestDescription' : 'description'}`}/>
                    </div>
                </div>
            </DialogWrapper>
        );
    }
}

export default StudioAbilities;
